import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomTableComponent } from '../../utils/custom-table/custom-table.component';
import { AppService } from '../../services/app.service';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../theme.service';
import { LoginUserModel } from '../../models/loginUserModel';
import { CustomTableIconComponent } from "../../utils/custom-table-icon/custom-table-icon.component";
import { LoaderComponent } from "../../utils/loader/loader.component";
import { ToastService } from '../../services/toast.service';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
    selector: 'app-mobile-devices',
    imports: [CommonModule, CustomTableIconComponent, LoaderComponent, ButtonModule, DialogModule],
    templateUrl: './mobile-devices.component.html',
    styleUrl: './mobile-devices.component.scss'
})
export class MobileDevicesComponent {
  devices: any[] = [];
  data!: LoginUserModel;
  loading = false;
  tableButtons: any[] = [];

  isConfirm = false;
  isSuccessMessage = true;
  messageModal = "";
  showConfirm = false;
  selectedDevices: any[] = [];
  txtButton = 'Aceptar';
  selectedDevice:any=null;
  headers = [{ key: "device_id", textHeader: "Dispositivo", visible: true }, { key: "name", textHeader: "Enlazado a", visible: true }, { key: "phone", textHeader: "Número enlazado", visible: true }, { key: "tipo", textHeader: "Tipo", visible: true }];

  constructor(private svc: AppService, private titleService: Title, private themeService: ThemeService,private toastSrv:ToastService) {
    this.titleService.setTitle("Dispositivos vinculados");
    this.themeService.setTitle("Dispositivos vinculados");

    this.data = JSON.parse(localStorage.getItem('data')!);
  }



  ngOnInit() {
    if (this.data.UserType == 'Administrator') {
      this.tableButtons = [{
        text: 'Desvincular',
        action: (event: any) => this.unlink(event),
        icon: undefined,
        hasIcon: false,
        color: "",
        showText: true,
      }]
    }
    this.loadDevices();

  }


  loadDevices() {
    this.loading = true;
    this.svc.getLinkedDevices(this.data.Client_number).subscribe({
      next: (resp: any) => {
        var response = resp;
        this.devices = resp.map((rd: any) => {
          return {
            device_id: rd.deviceId,
            tipo: rd.driverId > 0 ? 'Conductor' : 'Usuario',
            name: rd.name,
            phone: rd.phone
          }
        })
      },
      error: (err: any) => {
        this.devices = [];
      },
      complete: () => {
        this.loading = false;
      }
    })

  }

  unlink(event: any) {
    this.selectedDevice = event;
    this.messageModal = 'Se desvinculará el dispositivo ' + event.device_id + ', ¿Desea continuar?';
    this.showConfirm = true;
  }


  selectDevice(event: any) {

    this.selectedDevices = event.filter((item: any) => item.type === 2);

  }

  doUnlink() {
    this.showConfirm = false;
    this.loading = true;
    this.svc.unlinkDevicePortal(this.selectedDevice).subscribe({
      next: (resp: any) => {
        this.toastSrv.add({ type: 'success', message: resp.message });
        this.loadDevices();
      },
      error: (err: any) => {
        this.toastSrv.add({ type: 'error', message: 'No se pudo desvincular el dispositivo, intente de nuevo.' });
      },
      complete: () => {
        this.loading = false;
      }
    });

    }
  }




